<template>
  <el-container class="research">
    <el-aside class="research-left">
      <div class="research-search">
        <el-cascader
          class="research-select"
          clearable
          v-model="courseIds"
          :show-all-levels="false"
          :props="subjectTreeProps"
          placeholder="请输入所属科目课程"
          :options="subjectTreeList"
          @change="subjectSearchChange"
        ></el-cascader>
        <el-tree
          :data="ChapterTree"
          :props="ChapterProps"
          :default-expanded-keys="[chapterForm.id]"
          :highlight-current="true"
          :expand-on-click-node="false"
          class="research-tree"
          ref="tree"
          node-key="id"
          current-node-key
        >
          <span class="span-ellipsis" slot-scope="{ node, data }">
            <span :title="data.name" @click="choseChapterId(data,node);">{{ data.name }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>
    <el-main class="research-right">
      <el-card>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学习资料" name="first" class="tab-type">
            <material :chapterForm="chapterForm" @materialChange="materialChange" v-if="activeName=='first'"></material>
          </el-tab-pane>

          <el-tab-pane label="课堂练习" name="second" class="tab-type">
            <questionList :chapterForm="chapterForm" v-if="activeName == 'second'"></questionList>
          </el-tab-pane>

          <el-tab-pane label="课后作业" name="third" class="tab-type">
            <homeworkQuestionList :chapterForm="chapterForm" v-if="activeName == 'third'"></homeworkQuestionList>
          </el-tab-pane>

        </el-tabs>
      </el-card>
    </el-main>



  </el-container>
</template>

<script>
import material from './components/material'
import questionList from './components/questionList'
import homeworkQuestionList from './components/homeworkQuestionList'
export default {
  components: {material,questionList,homeworkQuestionList},
  data() {
    return {
      admin: JSON.parse(localStorage.getItem("user")).admin,
      formLabelWidth: "0px",
      videoDialog: false,
      courseIds: [],
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      ChapterTree: [],
      ChapterProps: {
        children: "children",
        label: "name"
      },
      VideoTree: [],
      VideoProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      activeName: "first",
      classRoomSearch: {
        pageNumber: 1,
        pageSize: 10,
        questionTypeId: null,
        title: null,
        remark: null
      },
      searchForm: {
        courseId: null
      },
      addForm: {
        attachments: "",
        type: 1
      },
      chapterForm: {
        id: 0,
        type: 1,
        courseId: null
      },
      ids: [],
      addChapterMaterialsId: "",
      chapterMaterialsType: 1,
      type: 2,
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    closeDialog() {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    down(item) {
      window.open(item.url);
    },

    subjectSearchChange() {
      this.searchForm.courseId = this.courseIds[2];
      this.chapterForm.courseId = this.courseIds[2];
      this.getTree();
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeListByAgentId()
        .then(result => {
          if (result.data.length == 0) {
            this.loading = false;
            this.$message.error("暂无课程信息！");
          } else {
            for (let item of result.data) {
              if (item.children) {
                for (let items of item.children) {
                  if (items.children) {
                    for (let itemss of items.children) {
                      delete itemss.children;
                    }
                  } else {
                    delete items.children;
                  }
                }
              } else {
                delete item.children;
              }
            }
            this.subjectTreeList = result.data;
            this.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.searchForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
            this.chapterForm.courseId = this.subjectTreeList[0].children[0].children[0].id;
            this.getTree();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTree() {
      if(this.searchForm.courseId == null){
        return;
      }
      this.api.chapter
        .getChapterSelectListByCourse({ courseId: this.searchForm.courseId })
        .then(result => {
          this.ChapterTree = result.data;
          if (this.ChapterTree.length > 0) {
            this.activeName = "first";
            this.chapterMaterialsType = 1;
            this.type = 2;
            this.chapterForm.id = this.ChapterTree[0].children[0].id;
            this.addChapterMaterialsId = this.ChapterTree[0].children[0].id;
            this.$nextTick(function() {
              this.$refs.tree.setCurrentKey(this.addChapterMaterialsId);
            });
          } else {
            this.$message.warning("该科目暂无章节");
            this.activeName = "first";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    choseChapterId(item,node) {
      console.log("node",node.level)
      if(node.level==1){
        this.$message.error("请点击节获取信息！")
      }else{
        this.chapterForm.id = item.id;
      }
    },




    /*-----------------------------------------讲义操作----------------------------------- */
    materialChange(ids){
      console.log("ids",ids)
    },

    /*-----------------------------------------tab切换----------------------------------- */
    handleClick(){
      if(this.activeName == 'first'){
        this.chapterForm.type = 1
      }else if(this.activeName == 'second'){
        this.chapterForm.type = 2
      }else if(this.activeName == 'third'){
        this.chapterForm.type = 3
      }

    },

  },
  watch: {
    dataDialogVisible: function(newVal) {
      if (!newVal) {
        this.getChapterMaterialsList();
      } else {
      }
    }
  },
  mounted() {
    this.getSubjectTreeList();
  },
};
</script>
<style scoped>
.research {
  /* background-color: #fff; */
}
.research-left {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
  /* border-right: 1px solid rgba(238, 238, 238, 1); */
}
.research-right {
  padding: 0px 20px !important;
}
.tab-type {
  padding: 20px;
  padding-top: 0px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.left-top {
  padding: 0px 20px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  height: 48px;
  line-height: 48px;
}
.left-top-text {
  float: left;
}
.left-top-botton {
  margin-top: 10px;
  float: right;
}
.research-search {
  padding: 0px 20px;
}
.research-select {
  width: 100%;
  margin-top: 20px;
}
.research-tree {
  margin-top: 10px;
  padding-bottom: 20px;
}
.research-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}
.research-icon-right {
  float: right;
  margin: 10px;
  font-size: 13px;
  color: #409eff;
}
.classRoomButton {
  /* height: 40px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 40px;
  color: #fff; */
  font-size: 14px;
  cursor: pointer;
}
.addNote-button {
  height: 32px;
  width: 100px;
  border: 1px solid rgba(77, 148, 255, 1);
  color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.videoPlay {
  display: flex;
}
.videoPlay-left {
  width: 75%;
}
.videoPlay-right {
  width: 25%;
  background-color: rgba(246, 249, 250, 1);
  padding: 10px;
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
.warpper
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 255, 255);
  color: rgb(64, 158, 255);
}
</style>
<style lang="less">
.research {
  .el-card__body {
    padding: 0px !important;
  }
  .el-upload-list {
    display: none !important;
  }
  .el-tabs__nav-scroll {
    height: 49px !important;
    line-height: 49px;
  }
  .el-tabs__nav {
    margin-left: 20px;
  }
  .previewBox {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    .el-dialog {
      width: 320px;
      height: 606px;
      margin: inherit;
      border-radius: 50px;
      margin-top: 0 !important;
      .el-dialog__header {
        height: 0;
        width: 0;
        padding: 0;
        opacity: 0;
      }
      .el-dialog__body {
        padding: 0;
        .mobileBg {
          width: 324px;
          height: 606px;
        }
        .content {
          position: relative;
          top: -540px;
          left: 22px;
          width: 280px;
          line-height: 20px;
          font-size: 15px;
          height: 460px !important;
          overflow-y: scroll;
          margin: 0;
          overflow-x: hidden;
          .content-top {
            height: 44px;
            line-height: 44px;
            text-align: center;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
          }
          .content-buttom {
            width: 40px;
            line-height: 28px;
            border: 1px solid rgba(238, 238, 238, 1);
            color: #37aefe;
            text-align: center;
            cursor: pointer;
            position: relative;
            top: -35px;
            left: 225px;
          }
          .attachList {
            margin-bottom: 20px;
            a {
              text-decoration: none;
            }
          }
        }
      }
    }
    img {
      max-width: 100%;
    }
  }
  // .research-tree {
  //   padding-bottom: 0px;
  //   .el-tree-node__label {
  //     font-size: 13px;
  //     color: #a2aabc;
  //   }
  // }
  // .el-tree-node:focus > .el-tree-node__content {
  //   color: #409EFF;
  // }
  .videoPlay {
    .el-tree-node__content {
      background-color: rgb(255, 255, 255) !important;
    }
    .el-tree-node__content:hover {
      background-color: rgb(255, 255, 255) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teachingResearch/index.vue